import { createStore, applyMiddleware, compose } from "redux";
import { persistStore } from "redux-persist";
import thunk from "redux-thunk";
// import logger from "redux-logger";
import reducers from "./reducers";

let InitialState = {
    article:{}
}
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
    reducers,
    InitialState,
    composeEnhancers(applyMiddleware(thunk)));
export const persistor = persistStore(store);
